"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var translation_1 = require("../../utils/translation");
var Buttons = function (props) {
    return (React.createElement("div", { className: !props.isMobile
            ? 'sok-thumbnail-buttons'
            : 'sok-thumbnail-buttons-mobile' },
        props.onOpen && (React.createElement("div", { className: "sok-button-container" },
            React.createElement(Button_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fas fa-external-link-alt" }), size: "small", color: "white", onClick: props.onOpen }),
            props.isMobile && (React.createElement("div", null, (0, translation_1.getLocalization)("".concat(props.localizationPrefix !== undefined
                ? props.localizationPrefix
                : '', "open")))))),
        props.onDownload && (React.createElement("div", { className: "sok-button-container" },
            React.createElement(Button_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fas fa-cloud-download" }), size: "small", color: "white", onClick: props.onDownload }),
            props.isMobile && (React.createElement("div", null, (0, translation_1.getLocalization)("".concat(props.localizationPrefix !== undefined
                ? props.localizationPrefix
                : '', "download")))))),
        props.onEdit && (React.createElement("div", { className: "sok-button-container" },
            React.createElement(Button_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fas fa-cog" }), size: "small", color: "white", onClick: props.onEdit }),
            props.isMobile && (React.createElement("div", null, (0, translation_1.getLocalization)("".concat(props.localizationPrefix !== undefined
                ? props.localizationPrefix
                : '', "edit")))))),
        props.onDelete && (React.createElement("div", { className: "sok-button-container" },
            React.createElement(Button_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fas fa-times-circle" }), size: "small", color: "white", onClick: props.onDelete }),
            props.isMobile && (React.createElement("div", null, (0, translation_1.getLocalization)("".concat(props.localizationPrefix !== undefined
                ? props.localizationPrefix
                : '', "delete"))))))));
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('showButtons', 'setShowButtons', false), recompose_1.pure);
exports.Thumbnail = enhance(function (props) {
    var style;
    props.height || props.width
        ? (style = { height: props.height, width: props.width })
        : (style = {});
    return (React.createElement("div", { style: style, className: classNames('sok-thumbnail', props.className, props.showButtons && props.isMobile && 'sok-thumbnail-focus'), onMouseEnter: function () { return props.setShowButtons(true); }, onMouseLeave: function () { return props.setShowButtons(false); }, onClick: function () { return props.setShowButtons(true); } },
        React.createElement("img", { className: classNames('sok-thumbnail-img', props.className), src: props.imageSrc }),
        props.showButtons && React.createElement(Buttons, __assign({}, props))));
});
//# sourceMappingURL=index.js.map